import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Get_Widget_Cdn } from "../../redux/SuperAdmin/SuperAdminActions";

const FALLBACK_WIDGET_CDN_URL = "https://cdnnew.convobird.com/media/chat-widget.umd.cjs";

const buildEmbedScript = (cdnUrl, brandToken) =>
  `<script src="${cdnUrl}" token="${brandToken || ""}"></script>`;

function ClipboardCopy({ BrandToken }) {
  const dispatch = useDispatch();
  const widgetCdnUrl = useSelector((state) => state.SuperAdminReducer.widgetCdnUrl);
  const cdnUrl = widgetCdnUrl || FALLBACK_WIDGET_CDN_URL;
  const [copied, setCopied] = useState(false);
  const [textToCopy, setTextToCopy] = useState(buildEmbedScript(cdnUrl, BrandToken));

  useEffect(() => {
    dispatch(Get_Widget_Cdn());
  }, [dispatch]);

  useEffect(() => {
    setTextToCopy(buildEmbedScript(cdnUrl, BrandToken));
    setCopied(false);
  }, [cdnUrl, BrandToken]);

  const copyToClipboard = () => {
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = textToCopy;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    setCopied(true);
  };

  const handleDivClick = () => {
    copyToClipboard();
  };

  return (
    <div className="clipboard">
      <div className="copiedArea" onClick={handleDivClick}>
        {textToCopy}
      </div>
      {copied && (
        <div>
          <div className="copiedText">Copied to clipboard!</div>
        </div>
      )}
    </div>
  );
}

export default ClipboardCopy;
